import { IconButton } from '@mui/material';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from '../../../constants';
import { useGlobalLocaleContext } from '../../../context/contexts';
import {
  API_DATE_FORMAT,
  ENGLISH_SHORT_DATE_FORMAT,
  JAPANESE_SHORT_DATE_FORMAT,
} from '../../../date/date-constants';
import { getMomentDate } from '../../../date/date-utils';

interface CustomDatePickerProps {
  value: string;
  isOpen: boolean;
  toggleDatePicker: (isOpen: boolean) => void;
  onChange: (date: moment.Moment | null) => void;
  minDate: moment.Moment | null;
  maxDate: moment.Moment | null;
}

const PickerButton = (params: {
  setOpen: () => void;
  InputProps: { ref: React.Ref<HTMLButtonElement> };
}) => {
  const { t } = useTranslation();
  const ariaLabel = t('common:timeSlider.datePicker.openDatePickerLabel');
  const { setOpen, InputProps: { ref } = {} } = params;
  return (
    <IconButton
      ref={ref}
      onClick={() => setOpen()}
      sx={{ color: 'white' }}
      aria-label={ariaLabel}
    >
      <CalendarIcon />
    </IconButton>
  );
};

export const CustomDatePicker = (props: CustomDatePickerProps) => {
  const { value, isOpen, toggleDatePicker, onChange, minDate, maxDate } = props;
  const { selected } = useGlobalLocaleContext();
  const dateFormat =
    selected === Languages.JA
      ? JAPANESE_SHORT_DATE_FORMAT
      : ENGLISH_SHORT_DATE_FORMAT;
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        format={dateFormat}
        value={getMomentDate(value, API_DATE_FORMAT)}
        open={isOpen}
        onOpen={() => toggleDatePicker(true)}
        onClose={() => toggleDatePicker(false)}
        onYearChange={(date) => {
          onChange(date);
        }}
        onMonthChange={(date) => {
          onChange(date);
        }}
        views={['month', 'year']}
        disableFuture={true}
        minDate={minDate ?? undefined}
        maxDate={maxDate ?? undefined}
        slots={{
          field: PickerButton,
        }}
        slotProps={{
          // copied from mui-example in v7 date picker docs
          // https://v7.mui.com/x/react-date-pickers/custom-field/
          field: {
            setOpen: () => toggleDatePicker(!isOpen),
          } as any,
        }}
      />
    </LocalizationProvider>
  );
};
